export default {
    methods: {
        async executeRecaptcha()
        {
            return window.grecaptcha.execute( window._rootData.recaptchaSitekey, { action: 'register' });
        }
    }
};
